<section class="cart-section">
  <div class="container">

    <!-- ── Page header ───────────────────────────────────────────────── -->
    <div class="cart-page-header">
      <h2 class="cart-page-title">
        <span class="material-icons">shopping_cart</span>
        {{ "cart" | translate }}
      </h2>
      @if (!isLoading && shoppingCartItems.length) {
        <span class="cart-item-count">{{ shoppingCartItems.length }} {{ shoppingCartItems.length === 1 ? 'producto' : 'productos' }}</span>
      }
    </div>

    <!-- ── Loading ────────────────────────────────────────────────────── -->
    @if (isLoading) {
      <div class="cart-loading">
        <mat-spinner diameter="40"></mat-spinner>
        <p>{{ "loading" | translate }}…</p>
      </div>
    }

    <!-- ── Empty cart ─────────────────────────────────────────────────── -->
    @if (!isLoading && !shoppingCartItems.length) {
      <div class="cart-empty">
        <span class="material-icons cart-empty__icon">shopping_cart</span>
        <p class="cart-empty__title">{{ "cart-empty" | translate }}</p>
        <button [routerLink]="['/home']" mat-stroked-button color="primary">
          {{ "cart-table.continue-shopping" | translate }}
        </button>
      </div>
    }

    <!-- ── Cart table ─────────────────────────────────────────────────── -->
    @if (!isLoading && shoppingCartItems.length) {
      <div class="cart-card">

        <!-- Column headers (desktop) -->
        <div class="cart-row cart-row--header">
          <div class="cart-col cart-col--img"></div>
          <div class="cart-col cart-col--name">{{ "cart-table.product-name" | translate }}</div>
          <div class="cart-col cart-col--price">{{ "cart-table.price" | translate }}</div>
          <div class="cart-col cart-col--qty">{{ "cart-table.quantity" | translate }}</div>
          <div class="cart-col cart-col--subtotal">{{ "cart-table.total" | translate }}</div>
          <div class="cart-col cart-col--action"></div>
        </div>

        <!-- Items -->
        @for (item of shoppingCartItems; track item) {
          <div class="cart-row cart-row--item">

            <!-- Image -->
            <div class="cart-col cart-col--img">
              <a [routerLink]="['/home/left-sidebar/product', item.product?.sku]">
                <img [src]="getUrl(item.product?.photos)" [alt]="item.product?.name" class="cart-img" />
              </a>
            </div>

            <!-- Name -->
            <div class="cart-col cart-col--name">
              <a class="cart-product-name" [routerLink]="['/home/left-sidebar/product', item.product?.sku]">
                {{ item.product?.name }}
              </a>
              <span class="cart-product-sku">SKU: {{ item.product?.sku }}</span>
            </div>

            <!-- Unit price -->
            <div class="cart-col cart-col--price">
              <span class="cart-label-mobile">Precio:</span>
              <span class="cart-price">$ {{ getPrice(item.product) }}</span>
            </div>

            <!-- Quantity -->
            <div class="cart-col cart-col--qty">
              <span class="cart-label-mobile">Cantidad:</span>
              <div class="qty-control">
                <button class="qty-btn" type="button" (click)="decrement(item.product)">−</button>
                <input
                  type="text"
                  class="qty-input"
                  [(ngModel)]="item.quantity"
                  (focusout)="update(item)"
                  maxlength="3"
                />
                <button class="qty-btn" type="button" (click)="increment(item.product)">+</button>
              </div>
            </div>

            <!-- Subtotal -->
            <div class="cart-col cart-col--subtotal">
              <span class="cart-label-mobile">Subtotal:</span>
              <span class="cart-subtotal">$ {{ getSubtotal(item) }}</span>
            </div>

            <!-- Remove -->
            <div class="cart-col cart-col--action">
              <button class="cart-remove-btn" type="button" (click)="removeItem(item)" title="Eliminar">
                <span class="material-icons">delete_outline</span>
              </button>
            </div>

          </div>
        }

        <!-- ── Summary footer ──────────────────────────────────────── -->
        <div class="cart-footer">

          <!-- Stock note -->
          <div class="cart-note">
            <span class="material-icons cart-note__icon">info_outline</span>
            <span class="cart-note__text">
              <strong>Nota:</strong> la web no gestiona stock en tiempo real. La disponibilidad será confirmada luego de su compra.
            </span>
          </div>

          <!-- Total + actions -->
          <div class="cart-summary">
            <div class="cart-total">
              <span class="cart-total__label">{{ "cart-table.total-price" | translate }}</span>
              <span class="cart-total__value">$ {{ getTotal() | async }}</span>
            </div>
            <div class="cart-actions">
              <button [routerLink]="['/home']" mat-stroked-button color="primary" class="cart-btn-secondary">
                {{ "cart-table.continue-shopping" | translate }}
              </button>
              <button [routerLink]="['/home/checkout']" mat-raised-button color="primary" class="cart-btn-primary">
                {{ "cart-table.check-out" | translate }}
              </button>
            </div>
          </div>

        </div>

      </div>
    }

  </div>
</section>
